import {createFeatureSelector, createSelector} from '@ngrx/store';
import { subscriptionsFeatureKey, SubscriptionsState } from './subscriptions.reducer';
import { LibOptionValue } from 'daisy-design-system-front';
import {SubscriptionList} from "../../../swagger-gen/web-secured/models/subscription-list";
import {Subscription} from "../../../swagger-gen/web-secured/models/subscription";

const selectSubscriptionsState = createFeatureSelector<SubscriptionsState>(subscriptionsFeatureKey);

export const selectSubscriptionsForm = createSelector(
    selectSubscriptionsState,
    state => state
);

export const selectSubscriptionsList = createSelector(
    selectSubscriptionsState,
    state => state?.subscriptions || []
);

export const selectSubscriptionOptions = createSelector(
    selectSubscriptionsState,
    state => convertToOptions(state?.subscriptions || [])
);

export const selectSubscriptionLoading = createSelector(
    selectSubscriptionsState,
    state => state.loading
);

export const selectSubscriptionsByUids = (subscriptionUids: string[]) => createSelector(
    selectSubscriptionsState,
    state => state?.subscriptions?.filter(subscription => subscriptionUids.includes(subscription.uid || '')) || []
);

function convertToOptions(subscriptions: SubscriptionList): LibOptionValue<string>[] {
  return subscriptions?.map(convertToOption) || [];
}

function convertToOption(subscription: Subscription): LibOptionValue<string> {
  return { label: subscription.name, value: subscription.uid || '' };
}
